import { render, staticRenderFns } from "./BookingOverviewCalendar.vue?vue&type=template&id=25ade858&scoped=true&"
import script from "./BookingOverviewCalendar.vue?vue&type=script&lang=js&"
export * from "./BookingOverviewCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ade858",
  null
  
)

export default component.exports